/* Fiche « stick anti-âge calcium + collagène » (modèle product.stick-calcium, 27/10/2026, cro-pages) : copie de la fiche Naila.
   Barre d'annonce, menu, galerie, offres 1 / 1+1 / 2+1, ajout au panier en AJAX puis tiroir de la page (sections/tb-panier,
   même mécanique que assets/ft.js), barre collante, minuteurs, carrousels, « Lire la suite », vidéos lues à l'écran.
   Suivi CRO : clics marqués data-cro lus par cro-tracker.js ; ouverture du tiroir lue sur [data-cro-panier-lateral]. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LG = document.documentElement.lang || 'fr';
  var T = $('[data-tb-t]') ? JSON.parse($('[data-tb-t]').textContent) : {};
  var d2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var post = function (url, corps) {
    return fetch(racine + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) });
  };

  /* ── Barre d'annonce : compte à rebours jusqu'à minuit (heure de la visiteuse), repart chaque jour ── */
  (function () {
    var a = $('[data-tb-minuit]'); if (!a) return;
    var H = $('[data-h]', a), M = $('[data-m]', a), S = $('[data-s]', a);
    function tic() {
      var n = new Date(), f = new Date(n); f.setHours(24, 0, 0, 0);
      var r = Math.max(0, Math.floor((f - n) / 1000));
      H.textContent = d2(Math.floor(r / 3600)); M.textContent = d2(Math.floor(r % 3600 / 60)); S.textContent = d2(r % 60);
    }
    tic(); setInterval(tic, 1000);
  })();

  /* ── Menu ── */
  (function () {
    var t = $('[data-tb-menu]'); if (!t) return;
    document.body.appendChild(t);
    $$('[data-tb-menu-ouvrir]').forEach(function (b) { b.addEventListener('click', function () { t.hidden = false; document.documentElement.style.overflow = 'hidden'; }); });
    $$('[data-tb-menu-fermer]', t).forEach(function (b) { b.addEventListener('click', function () { t.hidden = true; document.documentElement.style.overflow = ''; }); });
  })();

  /* ── Compteur du panier de l'en-tête ── */
  function majCompte() {
    fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-tb-compte]').forEach(function (e) { e.textContent = c.item_count; e.hidden = !c.item_count; });
    }).catch(function () {});
  }
  window.addEventListener('ajaxCart', majCompte);

  /* ── Tiroir de la page : dates de la frise (Intl, langue de la page), avis recopiés de la section tb-avis ── */
  function tiroirMaj(b) {
    var lg = LG === 'no' ? 'nb' : LG, d = function (t) { return new Date(+t * 1000); };
    $$('[data-tb-jour]', b).forEach(function (e) {
      try { e.textContent = new Intl.DateTimeFormat(lg, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d(e.dataset.tbJour)); }
      catch (x) { e.textContent = d(e.dataset.tbJour).toLocaleDateString(); }
    });
    $$('[data-tb-plage]', b).forEach(function (e) {
      var t = e.dataset.tbPlage.split('|'), f;
      try { f = new Intl.DateTimeFormat(lg, { day: 'numeric', month: 'short', timeZone: 'UTC' }); e.textContent = f.formatRange ? f.formatRange(d(t[0]), d(t[1])) : f.format(d(t[0])) + ' – ' + f.format(d(t[1])); }
      catch (x) { e.textContent = d(t[0]).toLocaleDateString() + ' – ' + d(t[1]).toLocaleDateString(); }
    });
    var car = $('[data-tbp-car]', b), pts = $('[data-tbp-points]', b);
    if (car && !car.children.length) {
      $$('#tb-avis .tb-avis__carte').slice(0, 6).forEach(function (c, k) {
        var a = document.createElement('div'); a.className = 'tbp-avis';
        var et = $('.tb-etoiles', c), h = $('h3', c), tx = $('.tb-avis__txt', c), nom = $('header strong', c);
        a.innerHTML = '<div class="tbp-avis-tete"></div><p class="tbp-avis-t"></p><p class="tbp-avis-txt"></p><button type="button" class="tb-lien" data-tbp-plus data-cro="avis_lire_plus" data-cro-value="tiroir-' + (k + 1) + '"></button><p class="tbp-avis-nom"></p>';
        if (et) $('.tbp-avis-tete', a).appendChild(et.cloneNode(true));
        $('.tbp-avis-t', a).textContent = h ? h.textContent : '';
        $('.tbp-avis-txt', a).innerHTML = tx ? tx.innerHTML : '';
        $('[data-tbp-plus]', a).textContent = T.plus || '+';
        $('.tbp-avis-nom', a).textContent = nom ? nom.textContent : '';
        car.appendChild(a);
        if (pts) { var p = document.createElement('i'); if (!k) p.className = 'on'; pts.appendChild(p); }
      });
      car.addEventListener('scroll', function () {
        var c = car.children[0]; if (!c || !pts) return;
        var i = Math.round(car.scrollLeft / (c.offsetWidth + 8));
        Array.prototype.forEach.call(pts.children, function (p, k) { p.classList.toggle('on', k === i); });
      }, { passive: true });
    }
  }

  var panier = (function () {
    var b = $('[data-tb-panier]'); if (!b) return null;
    document.body.appendChild(b);
    var tiroir = $('.tb-panier__tiroir', b);
    $$('[data-cro-panier-lateral]').forEach(function (e) { e.removeAttribute('data-cro-panier-lateral'); });
    tiroir.setAttribute('data-cro-panier-lateral', '');
    var CLE = 'sloown-panier-expire', DUREE = 15 * 60 * 1000;
    function nb() { var i = $('[data-tb-panier-in]', b); return i ? +i.dataset.nb : 0; }
    function minuteur() {
      var fin = 0;
      try {
        fin = +localStorage.getItem(CLE) || 0;
        if (!nb()) { localStorage.removeItem(CLE); fin = 0; }
        else if (!fin) { fin = Date.now() + DUREE; localStorage.setItem(CLE, fin); }
      } catch (x) {}
      var r = fin ? Math.max(0, Math.round((fin - Date.now()) / 1000)) : 0;
      $$('[data-tb-minuteur-temps]', b).forEach(function (e) { e.textContent = d2(Math.floor(r / 60)) + ':' + d2(r % 60); });
      $$('[data-tb-minuteur]', b).forEach(function (e) { e.hidden = !r; });
    }
    setInterval(function () { if (!b.hidden) minuteur(); }, 1000);
    function ouvrir() {
      b.hidden = false; minuteur(); tiroirMaj(b);
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-ouvert'); tiroir.setAttribute('aria-hidden', 'false'); }); });
    }
    function fermer() {
      b.classList.remove('is-ouvert'); tiroir.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!b.classList.contains('is-ouvert')) b.hidden = true; }, 300);
    }
    function recharger() {
      var sid = b.dataset.sid;
      return fetch(location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sec) {
        var d = document.createElement('div'); d.innerHTML = sec[sid];
        var neuf = $('[data-tb-panier-in]', d), vieux = $('[data-tb-panier-in]', b);
        if (neuf && vieux) vieux.parentNode.replaceChild(neuf, vieux);
        tiroirMaj(b);
        // Minuteur du thème (layout/theme.liquid) : il lit le nombre d'articles sur son tiroir, jamais rechargé ici.
        var c = $('#cart'), t = $('#cart [data-totalqty]');
        if (c && !t) { t = document.createElement('div'); t.hidden = true; c.appendChild(t); }
        if (t) t.setAttribute('data-totalqty', nb());
        minuteur(); majCompte();
      });
    }
    b.addEventListener('click', function (e) {
      if (e.target.closest('[data-tb-panier-fermer]')) { fermer(); return; }
      var pl = e.target.closest('[data-tbp-plus]');
      if (pl) { var av = pl.closest('.tbp-avis'); if (av) { var o = av.classList.toggle('is-ouvert'); pl.textContent = o ? T.moins : T.plus; } return; }
      var aj = e.target.closest('[data-tb-panier-ajout]');
      if (aj) {
        $('[data-tb-panier-in]', b).classList.add('is-maj');
        post('cart/add.js', { items: [{ id: +aj.dataset.tbPanierAjout, quantity: +aj.dataset.q || 1 }] }).then(recharger, recharger).catch(function () { location.href = racine + 'cart'; });
        return;
      }
      var q = e.target.closest('[data-tb-qte]'); if (!q) return;
      var l = q.closest('[data-ligne]'), n = Math.max(0, +l.dataset.q + +q.dataset.tbQte);
      $('[data-tb-panier-in]', b).classList.add('is-maj');
      post('cart/change.js', { line: +l.dataset.ligne, quantity: n }).then(recharger).catch(function () { location.href = racine + 'cart'; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !b.hidden) fermer(); });
    $$('[data-tb-panier-ouvrir]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); ouvrir(); recharger().catch(function () {}); }); });
    return { ouvrir: ouvrir, recharger: recharger };
  })();

  /* ── Liens vers une partie de la page (note → avis, boutons → offres) ── */
  $$('[data-tb-vers]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var c = $(a.getAttribute('data-tb-vers')); if (!c) return;
      e.preventDefault();
      var h = ($('.tb-entete') || {}).offsetHeight || 0;
      window.scrollTo({ top: c.getBoundingClientRect().top + window.pageYOffset - h - 12, behavior: 'smooth' });
    });
  });

  /* ── Carrousels d'avis : flèches (une carte) ── */
  $$('[data-tb-car]').forEach(function (c) {
    var p = $('[data-tb-car-piste]', c);
    $$('[data-tb-car-fl]', c).forEach(function (f) {
      f.addEventListener('click', function () { var k = p.children[0]; p.scrollBy({ left: +f.dataset.tbCarFl * ((k ? k.offsetWidth : 300) + 16), behavior: 'smooth' }); });
    });
  });

  /* ── « Lire la suite » des avis (seulement si le texte est coupé) ── */
  $$('[data-tb-plus]').forEach(function (b) {
    var txt = b.previousElementSibling;
    function besoin() { b.hidden = !txt.classList.contains('is-ouvert') && txt.scrollHeight <= txt.clientHeight + 2; }
    b.addEventListener('click', function () { var o = txt.classList.toggle('is-ouvert'); b.textContent = o ? T.moins : T.plus; });
    besoin(); window.addEventListener('resize', besoin); window.addEventListener('tb-avis-plus', besoin);
  });

  /* ── « Voir plus d'avis » : 6 de plus à chaque clic ── */
  (function () {
    var b = $('[data-tb-avis-plus]'), l = $('[data-tb-avis-liste]'); if (!b || !l) return;
    var pas = +l.dataset.pas || 6;
    b.addEventListener('click', function () {
      var cach = $$('.tb-avis__carte[hidden]', l);
      cach.slice(0, pas).forEach(function (c) { c.hidden = false; });
      b.hidden = cach.length <= pas;
      window.dispatchEvent(new Event('tb-avis-plus'));
    });
    // photo d'avis cliquée en haut : affiche la carte si elle est encore cachée
    $$('[data-tb-avis-voir]').forEach(function (a) { a.addEventListener('click', function () { var c = $('#tb-av-' + a.dataset.tbAvisVoir); if (c && c.hidden) { c.hidden = false; window.dispatchEvent(new Event('tb-avis-plus')); } }, true); });
  })();

  /* ── « Toutes les notes » sous le carrousel : notes sans commentaire (étoiles + date), filtre par étoiles, 24 par 24 ── */
  (function () {
    var z = $('[data-tb-notes]'); if (!z) return;
    var notes; try { notes = JSON.parse($('[data-tb-notes-json]', z).textContent) || []; } catch (e) { return; }
    var grille = $('[data-tb-notes-grille]', z), plus = $('[data-tb-notes-plus]', z), filtres = $('[data-tb-notes-filtres]', z);
    var pas = +z.dataset.pas || 24, vu = pas, filtre = 0, lang = document.documentElement.lang || 'fr', fmt;
    try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { fmt = null; }
    var etoile = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.8 6.6 7.1.6-5.4 4.7 1.6 7-6.1-3.7-6.1 3.7 1.6-7L2.1 9.7l7.1-.6z"/></svg>';
    function etoiles(n) { var h = ''; for (var i = 1; i <= 5; i++) h += '<span class="tb-etoile" style="--p: ' + (i <= n ? 100 : 0) + '%">' + etoile + '</span>'; return '<span class="tb-etoiles" aria-label="' + n + '/5">' + h + '</span>'; }
    function jour(d) { var p = String(d || '').split('-'); if (p.length !== 3 || !fmt) return d || ''; return fmt.format(new Date(+p[0], +p[1] - 1, +p[2])); }
    var nb = [0, 0, 0, 0, 0, 0]; notes.forEach(function (x) { nb[+x[0]] = (nb[+x[0]] || 0) + 1; });
    var h = '<button type="button" aria-pressed="true" data-n="0">' + z.dataset.txtToutes + '</button>';
    for (var k = 5; k >= 1; k--) if (nb[k]) h += '<button type="button" aria-pressed="false" data-n="' + k + '" data-cro="avis_notes_filtre" data-cro-value="' + k + '">' + k + '★ <small>' + nb[k] + '</small></button>';
    filtres.innerHTML = h;
    function dessiner() {
      var L = filtre ? notes.filter(function (x) { return +x[0] === filtre; }) : notes;
      grille.innerHTML = L.slice(0, vu).map(function (x) { return '<li>' + etoiles(+x[0]) + '<time>' + jour(x[1]) + '</time></li>'; }).join('');
      plus.hidden = L.length <= vu;
    }
    filtres.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      filtre = +b.dataset.n; vu = pas;
      $$('button', filtres).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      dessiner();
    });
    plus.addEventListener('click', function () { vu += pas; dessiner(); });
    dessiner();
  })();

  /* ── Vidéos : chargées et lues seulement à l'écran, en pause sinon ── */
  (function () {
    var vs = $$('[data-tb-video]'); if (!vs.length) return;
    if (!window.IntersectionObserver) { vs.forEach(function (v) { v.src = v.dataset.src; }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (!v.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.src) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vs.forEach(function (v) { io.observe(v); });
  })();

  /* ── Minuteurs d'offre (Naila : « se termine dans 12:45 ») : 15 min qui repartent, gardées pour la visite ── */
  (function () {
    var cs = $$('[data-tb-chrono]'); if (!cs.length) return;
    var fin = 0;
    try { fin = +sessionStorage.getItem('tb-chrono') || 0; } catch (x) {}
    function tic() {
      if (fin <= Date.now()) { fin = Date.now() + 15 * 60 * 1000; try { sessionStorage.setItem('tb-chrono', fin); } catch (x) {} }
      var r = Math.round((fin - Date.now()) / 1000);
      cs.forEach(function (c) { c.textContent = d2(Math.floor(r / 60)) + ':' + d2(r % 60); });
    }
    tic(); setInterval(tic, 1000);
  })();

  /* ── Pied de page : menus ouverts sur ordinateur ── */
  function piedOuvert() { if (window.matchMedia('(min-width: 990px)').matches) $$('.tb-pied__col').forEach(function (d) { d.open = true; }); }
  piedOuvert();

  var P = $('[data-tb-produit]');
  if (!P) return;

  /* ── Galerie : flèches, vignettes ↔ photo affichée ── */
  (function () {
    var piste = $('[data-tb-piste]', P), vigs = $$('.tb-galerie__vig', P), bv = $('[data-tb-vigs]', P);
    if (!piste) return;
    function courant() { return Math.round(piste.scrollLeft / piste.clientWidth); }
    function aller(i) { piste.scrollTo({ left: i * piste.clientWidth, behavior: 'smooth' }); }
    function majVig() {
      var i = courant();
      vigs.forEach(function (v, k) { v.classList.toggle('is-on', k === i); });
      if (vigs[i] && bv) bv.scrollTo({ left: vigs[i].offsetLeft - bv.clientWidth / 2 + vigs[i].clientWidth / 2, behavior: 'smooth' });
    }
    vigs.forEach(function (v) { v.addEventListener('click', function () { aller(+v.dataset.i); }); });
    $$('[data-tb-gal]', P).forEach(function (f) {
      f.addEventListener('click', function () { var n = piste.children.length, i = courant() + +f.dataset.tbGal; aller((i + n) % n); });
    });
    var t; piste.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(majVig, 90); }, { passive: true });
  })();

  /* ── Offres 1 / 2+1 / 3+2 : une ligne couleur + taille par débardeur ; seule l'offre cochée montre ses lignes ── */
  var V = []; try { V = JSON.parse($('[data-tb-v]', P).textContent); } catch (x) {}
  var offres = $$('[data-tb-offre]', P), champId = $('[data-tb-id]', P);
  function offre() { return offres.filter(function (o) { return o.classList.contains('is-on'); })[0] || offres[0]; }
  function variante(c, t) { for (var i = 0; i < V.length; i++) if (V[i].c === c && V[i].t === t) return V[i]; return null; }
  function varCouleur(c) { for (var i = 0; i < V.length; i++) if (V[i].c === c) return V[i]; return null; }
  function majLigne(l) {
    var c = $('[data-tb-couleur]', l).value, v = varCouleur(c), img = $('[data-tb-ligne-img]', l);
    if (v && img && v.i) img.src = v.i;
  }
  function majId() {
    var l = $('[data-tb-ligne]', offre()); if (!l) return;
    var v = variante($('[data-tb-couleur]', l).value, $('[data-tb-taille]', l).value) || varCouleur($('[data-tb-couleur]', l).value);
    if (v) champId.value = v.id;
  }
  offres.forEach(function (o) {
    function choisir() {
      if (o.classList.contains('is-on')) return;
      offres.forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
      majId();
    }
    o.addEventListener('click', function (e) { if (!e.target.closest('select')) choisir(); });
    o.addEventListener('keydown', function (e) { if (e.target === o && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); choisir(); } });
  });
  // Galerie : la photo de la couleur choisie
  function voirMedia(id) {
    var piste = $('[data-tb-piste]', P), d = id && $('[data-media="' + id + '"]', P); if (!piste || !d) return;
    piste.scrollTo({ left: d.offsetLeft, behavior: 'smooth' });
  }
  $$('[data-tb-ligne]', P).forEach(function (l) {
    $('[data-tb-couleur]', l).addEventListener('change', function () { majLigne(l); majId(); });
    $('[data-tb-taille]', l).addEventListener('change', function () { this.classList.toggle('is-vide', !this.value); majId(); err.hidden = true; });
  });
  /* ── Choix de la couleur : menu à images, copie du « imageDropdown » de graceease (Kaching Bundles, 30/10/2026, Abel).
     La case montre la photo + le nom de la couleur choisie ; ouverte, chaque couleur avec sa photo. Le <select> caché reste la source
     (même logique d'ajout). Choisir une couleur ne fait plus défiler la galerie (Abel). ── */
  var ddOuvert = null;
  function ddFermer() { if (!ddOuvert) return; ddOuvert.classList.remove('is-ouvert'); $('.tb-dd__btn', ddOuvert).setAttribute('aria-expanded', 'false'); ddOuvert = null; }
  $$('[data-tb-ligne]', P).forEach(function (l, k) {
    var sel = $('[data-tb-couleur]', l); if (!sel) return;
    var dd = document.createElement('div'); dd.className = 'tb-dd';
    var opts = Array.prototype.map.call(sel.options, function (o) { var v = varCouleur(o.value); return { val: o.value, nom: o.textContent, img: v && v.i ? v.i : '' }; });
    dd.innerHTML = '<button type="button" class="tb-dd__btn" aria-haspopup="listbox" aria-expanded="false"><img alt="" width="36" height="36"><span></span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<ul class="tb-dd__liste" role="listbox">' + opts.map(function (o) { return '<li role="option" data-val="' + o.val.replace(/"/g, '&quot;') + '" data-cro="choix_couleur" data-cro-label="' + o.val.replace(/"/g, '&quot;') + '" data-cro-value="' + (k + 1) + '"><img src="' + o.img + '" alt="" width="48" height="48"><span>' + o.nom + '</span></li>'; }).join('') + '</ul>';
    sel.parentNode.insertBefore(dd, sel); l.classList.add('has-dd');
    var btn = $('.tb-dd__btn', dd);
    function maj() {
      var o = opts.filter(function (x) { return x.val === sel.value; })[0] || opts[0];
      $('img', btn).src = o.img; $('span', btn).textContent = o.nom;
      $$('li', dd).forEach(function (li) { li.setAttribute('aria-selected', li.dataset.val === sel.value); });
    }
    maj(); sel.addEventListener('change', maj);
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (ddOuvert === dd) { ddFermer(); return; }
      ddFermer(); dd.classList.add('is-ouvert'); btn.setAttribute('aria-expanded', 'true'); ddOuvert = dd;
    });
    $('.tb-dd__liste', dd).addEventListener('click', function (e) {
      var li = e.target.closest('li'); if (!li) return;
      e.stopPropagation();
      if (sel.value !== li.dataset.val) { sel.value = li.dataset.val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      ddFermer();
    });
  });
  document.addEventListener('click', ddFermer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ddFermer(); });

  // ?offre=1|3|5 dans l'adresse coche cette offre (liens des futurs advertoriaux)
  (function () { var m = /[?&]offre=([135])/.exec(location.search), o = m && $('[data-tb-offre="' + m[1] + '"]', P); if (o) o.click(); })();

  /* ── Aide au choix de la taille (ouverte, copie du « Find my size » du concurrent) ──
     Grille du concurrent en pouces US : poitrine = tour de dos + rang du bonnet ; S < 35, M 35-36, L 37-38, XL 39-40, 2XL 41-43,
     3XL 44-46, 4XL 47-48, 5XL ≥ 49. Tour de poitrine mesuré : S < 89 cm, M < 94, L < 99, XL < 104, 2XL < 112, 3XL < 119, 4XL < 124.
     Système affiché selon le pays : fr (FR, BE, ES, PT : 80-125), eu (65-110), uk (30-48, bonnets anglais). */
  var TAILLES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  function tailleTour(p) { return p < 35 ? 0 : p < 37 ? 1 : p < 39 ? 2 : p < 41 ? 3 : p < 44 ? 4 : p < 47 ? 5 : p < 49 ? 6 : 7; }
  function tailleCm(c) { return c < 89 ? 0 : c < 94 ? 1 : c < 99 ? 2 : c < 104 ? 3 : c < 112 ? 4 : c < 119 ? 5 : c < 124 ? 6 : 7; }
  var err = $('[data-tb-erreur]', P);
  (function () {
    var g = $('[data-tb-guide]', P); if (!g) return;
    var sys = g.dataset.sys, dos = $('[data-tb-dos]', g), bon = $('[data-tb-bonnet]', g), res = $('[data-tb-res]', g), rt = $('[data-tb-res-taille]', g);
    var US = [30, 32, 34, 36, 38, 40, 42, 44, 46, 48];
    var DOS = sys === 'uk' ? US : US.map(function (u, i) { return (sys === 'fr' ? 80 : 65) + i * 5; });
    var BON = sys === 'uk' ? ['A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J'] : ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    var choixD = -1, choixB = -1;
    function boutons(box, liste, quoi) {
      box.innerHTML = liste.map(function (x, i) { return '<button type="button" role="radio" aria-checked="false" data-i="' + i + '" data-cro="guide_' + quoi + '" data-cro-value="' + x + '">' + x + '</button>'; }).join('');
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        $$('button', box).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
        if (quoi === 'dos') choixD = +b.dataset.i; else choixB = +b.dataset.i;
        if (choixD >= 0 && choixB >= 0) appliquer(tailleTour(US[choixD] + choixB + 1));
      });
    }
    // Mode « poids » (réglage guide_1688) : tailles du fabricant 1688, étiquette anglaise, d'après le poids (1 jin = 0,5 kg)
    var poids = $('[data-tb-poids]', g);
    if (poids) {
      poids.innerHTML = ['40–50', '50–60', '60–70', '70–80', '80–90', '90–100', '100–110', '110–120'].map(function (x, i) {
        return '<button type="button" role="radio" aria-checked="false" data-i="' + i + '" data-cro="guide_poids" data-cro-value="' + x + '">' + x + ' kg</button>'; }).join('');
      poids.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        $$('button', poids).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
        appliquer(+b.dataset.i);
      });
    } else { boutons(dos, DOS, 'dos'); boutons(bon, BON, 'bonnet'); }
    function appliquer(i) {
      var t = TAILLES[i]; rt.textContent = t; res.hidden = false;
      $$('[data-tb-taille]', P).forEach(function (s) { s.value = t; s.classList.remove('is-vide'); });
      majId(); err.hidden = true;
      try { sessionStorage.setItem('tb-taille', t); } catch (x) {}
      if (window.croTrack) try { window.croTrack('guide_taille_resultat', { label: t }); } catch (x) {}
    }
    var cm = $('[data-tb-cm]', g);
    function mesure() { var v = parseFloat(String(cm.value).replace(',', '.')); if (!v) return; if (v < 70) v *= 2.54; appliquer(tailleCm(v)); }
    if (cm) {
      $('[data-tb-cm-ok]', g).addEventListener('click', mesure);
      cm.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); mesure(); } });
    }
    $$('[data-tb-tableau]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); var d = $('#tb-tableau'); if (!d) return; d.open = true; var h = ($('.tb-entete') || {}).offsetHeight || 0; window.scrollTo({ top: d.getBoundingClientRect().top + window.pageYOffset - h - 12, behavior: 'smooth' }); }); });
    // Taille déjà trouvée dans cette visite : remise sur toutes les lignes
    try { var t0 = sessionStorage.getItem('tb-taille'); if (t0 && TAILLES.indexOf(t0) >= 0) { $$('[data-tb-taille]', P).forEach(function (s) { s.value = t0; s.classList.remove('is-vide'); }); rt.textContent = t0; res.hidden = false; } } catch (x) {}
  })();
  majId();

  /* ── Ajout au panier : vrai formulaire /cart/add (suivi CRO : add_to_cart_click), envoyé en AJAX avec items[] puis tiroir ── */
  var form = $('[data-tb-form]', P), bouton = $('[data-tb-ajout]', P);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var lignes = $$('[data-tb-ligne]', offre()), q = {}, ordre = [], manque = null;
    lignes.forEach(function (l) {
      var t = $('[data-tb-taille]', l);
      if (!t.value) { if (!manque) manque = t; return; }
      var v = variante($('[data-tb-couleur]', l).value, t.value);
      if (!v) return;
      if (!q[v.id]) { q[v.id] = 0; ordre.push(v); }
      q[v.id]++;
    });
    if (manque) {
      err.textContent = T.taille; err.hidden = false; manque.focus();
      var g = $('[data-tb-guide]', P); if (g) g.open = true;
      return;
    }
    var indispo = ordre.filter(function (v) { return !v.d; })[0];
    if (indispo) { err.textContent = T.indispo + ' (' + indispo.c + ' / ' + indispo.t + ')'; err.hidden = false; return; }
    err.hidden = true; bouton.disabled = true;
    // Shopify met chaque élément de items[] en tête du panier : envoyés à l'envers pour garder l'ordre #1, #2…
    var items = ordre.map(function (v) { return { id: v.id, quantity: q[v.id] }; }).reverse();
    fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        bouton.disabled = false;
        if (!panier) { location.href = racine + 'cart'; return; }
        return panier.recharger().then(panier.ouvrir).catch(function () { location.href = racine + 'cart'; });
      })
      .catch(function (d) { bouton.disabled = false; err.textContent = (d && (d.description || d.message)) || T.erreur; err.hidden = false; });
  });

  /* ── Barre d'achat collante : visible une fois le bouton « Ajouter au panier » dépassé ── */
  (function () {
    var st = $('[data-tb-sticky]', P); if (!st || !window.IntersectionObserver) return;
    document.body.appendChild(st);
    new IntersectionObserver(function (es) {
      var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true');
    }).observe(bouton);
  })();

  /* ── Pays de livraison : pays réel (en-tête Server-Timing « country », comme ft.js), sinon France ── */
  (function () {
    var e = $('[data-tb-pays]', P); if (!e) return;
    var code = null;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      ((nav && nav.serverTiming) || []).forEach(function (s) { if (s.name === 'country') code = s.description; });
      if (!code) code = sessionStorage.getItem('rs_pays');
    } catch (x) {}
    if (!code || !/^[A-Z]{2}$/.test(code) || code === e.dataset.code) return;
    var nom = code;
    try { nom = new Intl.DisplayNames([LG], { type: 'region' }).of(code); } catch (x) {}
    $('[data-tb-drapeau]', e).src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=32';
    $('[data-tb-pays-txt]', e).textContent = e.dataset.modele.replace('[p]', nom);
  })();
})();
